import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Dot from './Dot';

const LI = styled.li`
  display: flex;
  color: ${props => props.theme.color.textPrimary};
  font-size: 16px;
  font-family: ${props => props.theme.font.sourceSans};
  font-weight: ${props => props.theme.fontWeight.regular};
  line-height: 1.5;
  letter-spacing: 0.06px;
  & > div {
    align-self: auto;
  }
  & + & {
    margin: 20px 0 0 0;
  }

  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    font-size: 16px;

    & + & {
      margin: 9px 0 0 0;
    }
  }
`;

const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  padding-bottom: 1.4em;
`;

const List = ({ className, dotSize, items }) => (
  <UL className={className}>
    {items.map((item, index) => (
      <LI key={index}>
        <Dot dotSize={dotSize} />
        {item}
      </LI>
    ))}
  </UL>
);

List.propTypes = {
  className: PropTypes.string,
  dotSize: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default List;
